import { useEstateSuggestionGenerationState } from '@/modules/estate/hooks/useEstateSuggestionGenerationState';
import { WorkflowTrackerKind } from '@/types/schema';

interface UseIsGeneratingSuggestionsOptions {
  detailsWorkflowTrackerKind: WorkflowTrackerKind;
  onDetailsCompleted?: () => void | Promise<void>;
  onDispositiveProvisionsCompleted?: () => void | Promise<void>;
}

export function useIsGeneratingSuggestions(
  targetId: string | null | undefined,
  {
    detailsWorkflowTrackerKind,
    onDetailsCompleted,
    onDispositiveProvisionsCompleted,
  }: UseIsGeneratingSuggestionsOptions
): {
  isGeneratingDetails: boolean;
  isGeneratingDispositiveProvisions: boolean;
  isGeneratingSuggestions: boolean;
} {
  const isGeneratingDetails = useEstateSuggestionGenerationState({
    entityId: targetId,
    workflowTrackerKind: detailsWorkflowTrackerKind,
    onCompleted: onDetailsCompleted,
  });
  const isGeneratingDispositiveProvisions = useEstateSuggestionGenerationState({
    entityId: targetId,
    workflowTrackerKind: WorkflowTrackerKind.AiSuggestionsV2DpGeneration,
    onCompleted: onDispositiveProvisionsCompleted,
  });

  return {
    isGeneratingDetails,
    isGeneratingDispositiveProvisions,
    isGeneratingSuggestions:
      isGeneratingDetails || isGeneratingDispositiveProvisions,
  };
}
